import { useContext } from 'react';
import { ProductTourContext } from './product-tour-context';

export const useProductTour = () => useContext(ProductTourContext);
